import WhiteButton from '../../components/white-button';
import ModalsLib from '../../../lib/modals';

export default ({closeAction, welcome_bonus, nextStage}) => {    
    return (
        <div className="action-modal-body-container fix-width">
            <div className="action-modal-body-top">
                <div className="close" onClick={e => closeAction('close')}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div className="action-modal-body">
                <div className="girl"></div>
                <div className="content">
                    <div className="top">
                        <div className="title">
                            WELCOME<br/>BONUS
                        </div>
                        <div className="description">
                            Lorem ipsum is simply dummy text of the printing and typesetting industry
                        </div>
                    </div>
                    <div className="bonuses">
                        <div className="bonus">
                            <div className="details">
                                <span>{welcome_bonus.deposit_bonus}%</span>
                                Deposit bonus
                            </div>
                            <div className="line"></div>
                        </div>
                        {welcome_bonus.freeplay > 0 ? (
                            <div className="bonus">
                                <div className="details">
                                    <span>${welcome_bonus.freeplay}</span>
                                    Free Play
                                </div>
                                <div className="line"></div>
                            </div>
                        ) : <></>}
                    </div>
                    <div className="bottom">
                        <WhiteButton onClick={e => {
                            nextStage();
                        }}>Get bonus</WhiteButton>
                        <span>Lorem ipsum is simply dummy text of the printing and typesetting industry</span>
                    </div>
                </div>
            </div>
        </div>
    )
}